document.addEventListener("DOMContentLoaded", function () {
    let navbarToggler = document.querySelector(".navbar-toggler");
    let navbarTogglerIcon = document.querySelector(".navbar-toggler-icon");
    let headerLogo = document.querySelector(".header-logo");
    let menuItems = document.querySelectorAll(".menu-item");
    let navBarCollapse = document.querySelector(".navbar-collapse");

    navbarToggler.addEventListener("click", function () {
        navbarTogglerIcon.classList.toggle("opened");

        document.documentElement.classList.toggle('no-scroll');
        document.body.classList.toggle('no-scroll');
    });

    menuItems.forEach(function (menuItem) {
        menuItem.addEventListener("click", function (event) {
            if (!menuItem.classList.contains("pll-parent-menu-item")) {
                navBarCollapse.classList.remove("show");
                navbarTogglerIcon.classList.toggle("opened");

                document.documentElement.classList.remove('no-scroll');
                document.body.classList.remove('no-scroll');
            }
        });
    });
});
